import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ClipLoader } from 'react-spinners'
import moment from 'moment'
import { moneyize } from '../../../onestep-library/TextPresenters' 
import { submitResendInvoiceEmail } from '../actions'

function PendingInvoiceListing(props){
  const dispatch = useDispatch()
  const { pendingInvoices } = useSelector(state=>state.pendingInvoices)
  const organization = useSelector(state=>state.organization)
  const { issued_at, balance, name, id, stripe_invoice_id, resend_status, last_failed_at, due_date, max_current_date, overdue_invoice_reminder, overdue_days } = props

  function handleMakePayment(id){
    dispatch({
      type: 'LOAD_MAKE_PAYMENT',
      payload: {
        ...pendingInvoices.filter(invoice=>invoice.id === id)[0],
        paid_at: moment(max_current_date).format('MM/DD/YYYY'),
        description: '',
      }
    })
  }

  function handleResendInvoice(){
    dispatch(submitResendInvoiceEmail(id))
  }

  function handleOpenEditPendingInvoice(){
    dispatch({type: 'LOAD_EDIT_PENDING_INVOICE', payload: props })
  }

  function isOverdueOrUpcoming(){
    const days_until_due = moment(due_date).diff(moment(), 'days')

    if (!due_date) {
      return 'no_due_date'
    } else if (days_until_due >= 0) {
      return 'upcoming'
    } else if ( days_until_due < 0) {
      return 'overdue'
    }
  }

  function didChargeFail(){
    return !!last_failed_at
  }

  return(
    <tr className="hoverable">
      <td className="cursor-pointer" onClick={handleOpenEditPendingInvoice}>
        <div>{!!due_date ? moment(due_date, "YYYY-MM-DD").format("MMMM DD, YYYY") : <i>No Due Date</i>}</div>
        { didChargeFail() && <ChargeFailed/>}
        { isOverdueOrUpcoming() === 'upcoming' && <div className="badge badge-warning border-warning">UPCOMING</div> }
        { isOverdueOrUpcoming() === 'overdue' && <div className="badge badge-danger border-danger">OVERDUE</div> }
      </td>
      <td className="cursor-pointer" onClick={handleOpenEditPendingInvoice}>
        <div>{moment(issued_at, "YYYY-MM-DD").format("MMMM DD, YYYY")}</div>
      </td>
      <td className="cursor-pointer" onClick={handleOpenEditPendingInvoice} >
        <span
          className="text-primary" 
          href="#" 
          target="_blank">
          {name}
        </span>
      </td>
      <td className="cursor-pointer" onClick={handleOpenEditPendingInvoice}>{moneyize(balance)}</td>
      <td>
        <div 
          className="btn btn-sm text-info ml-3 p-0 text-center" 
          style={{minWidth: '114px', cursor: 'pointer'}}>
            { resend_status == 'resending' && <ClipLoader size={14} color=""/> }
            { resend_status == 'resend_successful' && <div className="text-secondary">Invoice emailed.</div> }
            { resend_status == 'error' && 
              <div onClick={handleResendInvoice}>
                <span className="text-danger">An Error Occurred.</span>
                <span className="text-primary"> Try Again?</span>
              </div> 
            }
            { !resend_status && !!organization.payment_processor && <div className="text-primary" onClick={handleResendInvoice}>Email Invoice</div> }
        </div>
      </td>
      <td className="text-primary">
        <button onClick={()=>handleMakePayment(id)} className="btn btn-sm border-info p-2 make-payment-button">Make Payment</button>
      </td>
    </tr>
  )
}

function ChargeFailed() {
  return(
    <>
      <div className="badge text-danger border-danger">CHARGE FAILED</div>
      <br/>
    </>
  )
}

export default PendingInvoiceListing
